export const Tooltip = {
    MuiTooltip: {
        defaultProps: {
            arrow: true
        },
        styleOverrides: {
            tooltip: ({ theme })=>({
                    backgroundColor: theme.palette.secondary.main
                }),
            arrow: ({ theme })=>({
                    color: theme.palette.secondary.main
                })
        }
    }
};

//# sourceMappingURL=Tooltip.js.map